import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectLimitsModalData, updateLimitsModal } from '~/components/account/ducks';
import Icon, { ICON_CLOSE } from '~/components/icon';
import { MainTitle } from '~/components/misc/section-head';
import useTranslations from '~/components/translation/use-translations';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer';

import { textKeys, getLimitsContent } from './constants';
import {
	ButtonOutlinedCustom,
	ButtonContainer,
	CloseButton,
	CloseIconWrapper,
	LimitContainer,
	SubTitle
} from './styled';

const RGLimit = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { translations: t } = useTranslations(textKeys);
	const { responsibleGamingLimitType } = useSelector(selectLimitsModalData) ?? {};
	const transformPath = useContextualPathTransformer();

	const limitContent = useMemo(() => getLimitsContent(responsibleGamingLimitType), [responsibleGamingLimitType]);

	const onClose = useCallback(
		(informMobileApps = true) => {
			dispatch(updateLimitsModal(false, {}, informMobileApps));
		},
		[dispatch]
	);

	const onClickClose = useCallback(() => {
		onClose();
	}, [onClose]);

	const onClick = useCallback(() => {
		navigate(transformPath(limitContent.navigateUrl));
		onClose(false);
	}, [navigate, onClose, transformPath, limitContent]);

	return (
		<LimitContainer data-at="spending-screen">
			<MainTitle padding="10px 18px">{t[limitContent.title]}</MainTitle>
			<SubTitle>{t[limitContent.subTitle]}</SubTitle>
			<CloseButton onClick={onClickClose}>
				<CloseIconWrapper>
					<Icon type={ICON_CLOSE} />
				</CloseIconWrapper>
			</CloseButton>
			<ButtonContainer>
				<ButtonOutlinedCustom data-at="spending-limit-modal" onClick={onClick}>
					{t[limitContent.buttonText]}
				</ButtonOutlinedCustom>
			</ButtonContainer>
		</LimitContainer>
	);
};

export default RGLimit;
